<template lang="pug">
v-dialog(
  v-model="popupDialog"
  transition="dialog-bottom-transition"
  width="900"
  )
  v-card
    v-toolbar(dense flat color="accent white--text")
      v-btn(icon @click.native="popupDialog = false" dark)
        v-icon close
      v-fade-transition(mode="out-in")
        v-toolbar-title Update Module
      v-spacer
      v-toolbar-items
        v-btn(flat @click="openUpdateDialog()" dark) Update
    v-card-title
      v-subheader Summary
      v-spacer
    v-card-text
      div(v-html="summary")
  update-c-e-module-dialog(
    :diff="diff"
    :publishId="publishId"
    :moduleId="moduleId"
    :show-dialog="showNewUpdateDialog"
    @closed="showNewUpdateDialog=false"
    @updateParent="updateParent"
  )
</template>

<script>
import Base from '../views/Base';
import UpdateCEModuleDialog from '../content/UpdateCEModuleDialog';

export default {
    name: 'ShowUpdateCEModuleDialog',
    extends: Base,

    components: {
        UpdateCEModuleDialog
    },

    props: {
        showDialog: { type: Boolean, required: true, default: false },
        summary: { type: String, required: true },
        diff: { type: String, required: true },
        publishId: { type: Number, required: true },
        moduleId: { type: Number, required: true },
    },

    data() {
        return {
            popupDialog: false,
            showNewUpdateDialog: false,
        };
    },

    watch: {
        showDialog(value) {
            if (value) {
                this.popupDialog = true;
            }
        },

        popupDialog(value) {
            if (!value) {
                this.$emit('closed');
            }
        },
    },

    methods: {
        openUpdateDialog() {
            this.showNewUpdateDialog = true;
            this.popupDialog = false;
        },

        updateParent() {
            this.$emit('updateSideNav');
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/content/ShowUpdateCEModuleDialog.vue